import * as React from 'react';

const NextSliderArrow = React.forwardRef((_, ref) => {
  return (
    <div
      className={'swiper-arrow arrow-right'}
      onClick={(event) => {
        event.stopPropagation();
      }}
      ref={ref}
    >
      <svg
        fill={'none'}
        height={24}
        viewBox={'0 0 24 24'}
        width={24}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={'M7.916 22H16.084C19.623 22 22 19.724 22 16.335V7.665C22 4.276 19.623 2 16.084 2H7.916C4.378 2 2 4.277 2 7.666L2 16.335C2 19.724 4.378 22 7.916 22Z'}
          fill={'#bcbcbc'}
          opacity={0.4}
        />
        <path
          d={'M12.855 16.2794L16.62 12.5314C16.903 12.2494 16.903 11.7504 16.62 11.4674L12.855 7.71943C12.561 7.42743 12.086 7.42843 11.794 7.72243C11.502 8.01643 11.502 8.49043 11.796 8.78343L14.273 11.2504H7.91797C7.50297 11.2504 7.16797 11.5864 7.16797 12.0004C7.16797 12.4144 7.50297 12.7504 7.91797 12.7504H14.273L11.796 15.2164C11.649 15.3634 11.576 15.5554 11.576 15.7484C11.576 15.9394 11.649 16.1314 11.794 16.2774C12.086 16.5704 12.561 16.5714 12.855 16.2794Z'}
          fill={'#FEFEFE'}
        />
      </svg>
    </div>
  );
});

export default NextSliderArrow;